import { render, staticRenderFns } from "./LegalPersonForm.vue?vue&type=template&id=d5804f86&"
import script from "./LegalPersonForm.vue?vue&type=script&lang=js&"
export * from "./LegalPersonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports